import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import DeliveryLocation from '../../models/DeliveryLocation'

export interface DeliveryLocationListState extends PaginatedApiState {
  deliveryLocations?: DeliveryLocation[]
}

const DeliveryLocationList = (state: DeliveryLocationListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    case 'DELIVERY_CLEAR':
          return { ...state, deliveryLocations: [] }
    default:
      return requestReducer<DeliveryLocationListState>('DELIVERY_LOCATION_LIST')(state, action)
  }
}

export default DeliveryLocationList
